import { render, staticRenderFns } from "./OnboardingNotification.vue?vue&type=template&id=87faa992&scoped=true"
import script from "./OnboardingNotification.vue?vue&type=script&lang=js"
export * from "./OnboardingNotification.vue?vue&type=script&lang=js"
import style0 from "./OnboardingNotification.vue?vue&type=style&index=0&id=87faa992&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87faa992",
  null
  
)

export default component.exports